import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c90e8828"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "header-navigation" };
import { computed, onBeforeMount } from "vue";
import { useStore } from "@/shared/composables/useStore";
import { ReferenceValuesTypes } from "@/store/modules/reference-values/types";
import { AllActionTypes } from "@/store/action-types";
import OneDeskNavigationItem from "@/components/atoms/OneDeskNavigationItem.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskNavigation',
    setup(__props) {
        onBeforeMount(async () => {
            await store.dispatch(AllActionTypes.GET_REFERENCE_VALUES, ReferenceValuesTypes.NAVIGATIONMENU);
        });
        const store = useStore();
        const navLinks = computed(() => store.getters[ReferenceValuesTypes.NAVIGATIONMENU]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navLinks.value, (link) => {
                    return (_openBlock(), _createBlock(OneDeskNavigationItem, {
                        key: link.id,
                        "navigation-menu-item": link
                    }, null, 8, ["navigation-menu-item"]));
                }), 128))
            ]));
        };
    }
});
